export interface Beneficiary {
  photo: string
  name: string
  email: string
  nid: string
  phone: string
  profession: string
  village: string
  status: 'approved' | 'pending' | 'rejected'
  date: string
}

export const beneficiaries: Beneficiary[] = [
  {
    photo: '👤',
    name: 'মোঃ আঃ গনি গাজী',
    email: 'goni.gazi@example.com',
    nid: '4715378236783',
    phone: '01712345601',
    profession: 'Jele (Fisher)',
    village: 'চৌকুনী',
    status: 'approved',
    date: '2024-04-01',
  },
  {
    photo: '👤',
    name: 'মোঃ আতিয়ার রহমান',
    email: 'atiyar.rahman@example.com',
    nid: '6420645506',
    phone: '01812345602',
    profession: 'Jele (Fisher)',
    village: 'চৌকুনী',
    status: 'pending',
    date: '2024-04-02',
  },
  {
    photo: '👤',
    name: 'আলাউদ্দীন শেখ',
    email: 'alauddin.shekh@example.com',
    nid: '4715378633574',
    phone: '01912345603',
    profession: 'Moual (Honey)',
    village: 'তেতুলতলা',
    status: 'approved',
    date: '2024-04-03',
  },
  {
    photo: '👤',
    name: 'মোঃ সাইদ হোসেন সানা',
    email: 'said.sana@example.com',
    nid: '19874715378000039',
    phone: '01612345604',
    profession: 'Jele (Fisher)',
    village: 'তেতুলতলার চর',
    status: 'rejected',
    date: '2024-04-04',
  },
  {
    photo: '👤',
    name: 'পরিমল ঢালী',
    email: 'porimal.dhali@example.com',
    nid: '4715355261079',
    phone: '01512345605',
    profession: 'Bawali (Wood)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-05',
  },
  {
    photo: '👤',
    name: 'শহিদ গাজী',
    email: 'shahid.gazi@example.com',
    nid: '4715355577643',
    phone: '01712345606',
    profession: 'Jele (Fisher)',
    village: '৫নং কয়রা',
    status: 'approved',
    date: '2024-04-06',
  },
  {
    photo: '👤',
    name: 'আকবর হোসেন',
    email: 'akbor.hosen@example.com',
    nid: '4715355592706',
    phone: '01812345607',
    profession: 'Moual (Honey)',
    village: '২নং কয়রা',
    status: 'pending',
    date: '2024-04-07',
  },
  {
    photo: '👤',
    name: 'বিল্লাল হোসেন',
    email: 'billal.hosen@example.com',
    nid: '19944715394000065',
    phone: '01912345608',
    profession: 'Bawali (Wood)',
    village: 'শেখ সরদার পাড়া',
    status: 'approved',
    date: '2024-04-08',
  },
  {
    photo: '👤',
    name: 'হোসেন',
    email: 'hosen@example.com',
    nid: '4715355592717',
    phone: '01612345609',
    profession: 'Jele (Fisher)',
    village: '২নং কয়রা',
    status: 'rejected',
    date: '2024-04-09',
  },
  {
    photo: '👤',
    name: 'হাসান',
    email: 'hasan@example.com',
    nid: '4715355592716',
    phone: '01512345610',
    profession: 'Jele (Fisher)',
    village: '২নং কয়রা',
    status: 'approved',
    date: '2024-04-10',
  },
  {
    photo: '👤',
    name: 'দূর্গাপদ বৈদ্য',
    email: 'durgapad.boiddo@example.com',
    nid: '4715355571463',
    phone: '01712345611',
    profession: 'Moual (Honey)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-11',
  },
  {
    photo: '👤',
    name: 'কালিপদ বৈদ্য',
    email: 'kalipad.boiddo@example.com',
    nid: '4715355571460',
    phone: '01812345612',
    profession: 'Bawali (Wood)',
    village: '৬নং কয়রা',
    status: 'pending',
    date: '2024-04-12',
  },
  {
    photo: '👤',
    name: 'খায়রুন্নেছা খাতুন',
    email: 'khairunnesa@example.com',
    nid: '4715355575470',
    phone: '01912345613',
    profession: 'Jele (Fisher)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-13',
  },
  {
    photo: '👤',
    name: 'মোঃ হযরত মৃধা',
    email: 'hozrot.mridha@example.com',
    nid: '4715355571412',
    phone: '01612345614',
    profession: 'Moual (Honey)',
    village: '৬নং কয়রা',
    status: 'rejected',
    date: '2024-04-14',
  },
  {
    photo: '👤',
    name: 'সন্তোষ মিস্ত্রী',
    email: 'sontosh.mistri@example.com',
    nid: '4715355571471',
    phone: '01512345615',
    profession: 'Bawali (Wood)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-15',
  },
  {
    photo: '👤',
    name: 'বিভাষ চন্দ্র মুন্ডা',
    email: 'bibhash.munda@example.com',
    nid: '4715322209921',
    phone: '01712345616',
    profession: 'Jele (Fisher)',
    village: 'জোড়শিং',
    status: 'approved',
    date: '2024-04-16',
  },
  {
    photo: '👤',
    name: 'রব্বানী গাজী',
    email: 'robbani.gazi@example.com',
    nid: '4715322587854',
    phone: '01812345617',
    profession: 'Moual (Honey)',
    village: 'জোড়শিং',
    status: 'pending',
    date: '2024-04-17',
  },
  {
    photo: '👤',
    name: 'মোঃ গোলাম গাজী',
    email: 'golam.gazi@example.com',
    nid: '4715355234390',
    phone: '01912345618',
    profession: 'Jele (Fisher)',
    village: '৩নং কয়রা',
    status: 'approved',
    date: '2024-04-18',
  },
  {
    photo: '👤',
    name: 'নিতাই বর্মন',
    email: 'nitai.bormon@example.com',
    nid: '4715355575543',
    phone: '01612345619',
    profession: 'Bawali (Wood)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-19',
  },
  {
    photo: '👤',
    name: 'রুহুল আমিন',
    email: 'ruhul.amin@example.com',
    nid: '4715355670444',
    phone: '01512345620',
    profession: 'Jele (Fisher)',
    village: '৩নং কয়রা',
    status: 'rejected',
    date: '2024-04-20',
  },
  {
    photo: '👤',
    name: 'আবু সাইদ',
    email: 'abu.said@example.com',
    nid: '4715378555427',
    phone: '01712345621',
    profession: 'Moual (Honey)',
    village: 'তেতুলতলা',
    status: 'approved',
    date: '2024-04-21',
  },
  {
    photo: '👤',
    name: 'কোবাদ গাজী',
    email: 'kobad.gazi@example.com',
    nid: '4715378555421',
    phone: '01812345622',
    profession: 'Jele (Fisher)',
    village: 'তেতুলতলা',
    status: 'pending',
    date: '2024-04-22',
  },
  {
    photo: '👤',
    name: 'আকাত আলী',
    email: 'akat.ali@example.com',
    nid: '19904715378000122',
    phone: '01912345623',
    profession: 'Bawali (Wood)',
    village: 'তেতুলতলা',
    status: 'approved',
    date: '2024-04-23',
  },
  {
    photo: '👤',
    name: 'আকবার হোসেন',
    email: 'akbar.hosen@example.com',
    nid: '4715378657471',
    phone: '01612345624',
    profession: 'Jele (Fisher)',
    village: 'তেতুলতলা',
    status: 'approved',
    date: '2024-04-24',
  },
  {
    photo: '👤',
    name: 'রবিউল সানা',
    email: 'robiul.sana@example.com',
    nid: '4715355261354',
    phone: '01512345625',
    profession: 'Moual (Honey)',
    village: '৬নং কয়রা',
    status: 'rejected',
    date: '2024-04-25',
  },
  {
    photo: '👤',
    name: 'আসমা খাতুন',
    email: 'asma.khatun@example.com',
    nid: '4715355571420',
    phone: '01712345626',
    profession: 'Jele (Fisher)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-26',
  },
  {
    photo: '👤',
    name: 'মফিজুল ইসলাম',
    email: 'mofizul.islam@example.com',
    nid: '4715355354664',
    phone: '01812345627',
    profession: 'Bawali (Wood)',
    village: '৪নং কয়রা',
    status: 'pending',
    date: '2024-04-27',
  },
  {
    photo: '👤',
    name: 'পরিমল মন্ডল',
    email: 'porimal.mondol@example.com',
    nid: '4715355571512',
    phone: '01912345628',
    profession: 'Jele (Fisher)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-28',
  },
  {
    photo: '👤',
    name: 'স্বপন রপ্তান',
    email: 'swopon.roptan@example.com',
    nid: '4715355571459',
    phone: '01612345629',
    profession: 'Moual (Honey)',
    village: '৬নং কয়রা',
    status: 'approved',
    date: '2024-04-29',
  },
]
